import {css} from '@emotion/react';
import styled from '@emotion/styled';

import {HelpTooltip} from '@/components/HelpTooltip';

type Props = {
  isBold: boolean;
  size: 'small' | 'medium' | 'large';
};

export const TotalPrice = styled('div')<Props>(({theme, isBold, size}) => {
  const fontStyles = {
    small: isBold
      ? theme.typography.labelSmallBold
      : theme.typography.labelSmall,
    medium: isBold
      ? theme.typography.labelXLargeBold
      : theme.typography.labelXLarge,
    large: isBold
      ? theme.typography.labelXxxLargeBold
      : theme.typography.labelXxxLarge,
  }[size];

  return css`
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
    gap: 4px;
    ${theme.typography.labelXSmall};
    white-space: nowrap;

    b {
      ${fontStyles};
    }

    ${HelpTooltip} {
      align-self: center;

      svg {
        font-size: 1rem;
      }
    }
  `;
});
